import { render, staticRenderFns } from "./BaseThumb.vue?vue&type=template&id=4683dc4e"
import script from "./BaseThumb.vue?vue&type=script&lang=js"
export * from "./BaseThumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports